import { Component, OnInit,ViewChild } from '@angular/core';
import { PaymentService} from 'app/shared/services/payment.service';
import { Payment } from 'app/shared/types/payment';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
export class PaymentListComponent implements OnInit {

  displayedColumns: string[] = ['voucherNo', 'paidDate', 'supplier', 'grnNo','paidTotal','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;

  isDark: boolean = false;

  payment : Payment[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  constructor(
              private paymentService : PaymentService, 
              private router : Router, 
              private route : ActivatedRoute, 
              private themeService: NbThemeService,
              private authService: AuthService,
             ) { }

  ngOnInit(): void {

    this.getAllPayments();
    this.getControlPermissions();
    
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='PMT'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  newButtonClick(){
    this.router.navigate(['../payment'],{relativeTo : this.route});
    }


    getAllPayments(){
    this.paymentService.getAll()
     .subscribe(
        (data) => {
                  this.payment = data; 
                  this.dataSource = new  MatTableDataSource (this.payment);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;    
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });       
       
     }
   

     viewDetailsButtonClick(voucherNo : string){   
        this.router.navigate(['../payment'],{queryParams : {'voucherNo':voucherNo},relativeTo : this.route});       
     }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }





} // end class
